
import { defineComponent, inject } from 'vue'
import TextInput from '@/components/shared/TextInput.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'
import { ForgotPasswordMessage } from '@/@types/messages/ForgotPasswordMessage'
import LockingButton from '@/components/shared/LockingButton.vue'
import { ErrorsResponse } from '@/@types/responses/common/ErrorsResponse'

export default defineComponent({
  name: 'ForgotPassword',
  components: {
    TextInput,
    LockingButton
  },
  props: {
    email: {
      type: String,
      default: ''
    }
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    return {
      miscellaneousService
    }
  },
  data() {
    return {
      emailAddress: this.email,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      showSuccessMessage: false
    }
  },
  computed: {
    formValid(): boolean {
      return this.emailAddress.trim() !== ''
    }
  },
  methods: {
    forgotPassword(): void {
      if (this.loading)
        return

      this.showErrorMessage = false
      this.loading = true

      const forgotPasswordMessage = new ForgotPasswordMessage(this.emailAddress)
      this.miscellaneousService.handleUserForgotPassword(forgotPasswordMessage).then(() => {
        this.loading = false
        this.showSuccessMessage = true
      }).catch(error => {
        const errorsResponse = error as ErrorsResponse

        this.loading = false
        this.errorMessage = errorsResponse.errors.map(e => e.message).join("\r\n")
        this.showErrorMessage = true
      })
    },
    onEnterPressed(): void {
      if (this.formValid)
        this.forgotPassword()
    }
  }
})
